


import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Grid,
  IconButton,
  Paper,
  Popover,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
  Tooltip,
} from "@mui/material";


import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import CloseIcon from '@mui/icons-material/Close';
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import ReactToPrint from "react-to-print";
import { editDeleteCylinderInward, getCylinderInwardList } from "../../../actions/actions";
import inwardService from "../../../services/inward.Service";
import HeaderSection from "../../reusableComponent/HeaderSection";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import supplierMasterService from "../../../services/masters/supplierMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import customerMasterService from "../../../services/masters/customerMaster.Service";
import { StyledTableCell, StyledTableRow, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, SearchInput, Breadcrumb } from "../../reusableComponent/Reusables";
import CustomPagination from "../../reusableComponent/CustomPagination";

const CylinderInwardList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;
  const depots = useSelector(state => state.depot.depotList || []);
  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.cylinder_inward.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.cylinder_inward.rows_per_page || 15);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState('');
  const [openCylinderDialog, setOpenCylinderDialog] = useState(false);
  const [selectedCylinderDetails, setSelectedCylinderDetails] = useState([]);
  const [dialogTitle, setDialogTitle] = useState("Cylinder Details");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const respMsgState = useSelector((state) => state.cylinder_inward.message);

  const [depotmap, setDepot] = useState([]);
  const [customermap, setCustomer] = useState([]);
  const [suppliermap, setSupplier] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [depotData, customerData, supplierData] = await Promise.all([
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
          customerMasterService.getCustomerList({ page: 0, size: 999, searchKey: "" }),
          supplierMasterService.getSupplierList({ page: 0, size: 999, searchKey: "" }),
        ]);

        setDepot(Object.fromEntries(depotData.map(d => [d.depot_id, d.depot_name])));
        setCustomer(Object.fromEntries(customerData.map(c => [c.cust_id, c.cust_name])));
        setSupplier(Object.fromEntries(supplierData.map(s => [s.supplier_id, s.supplier_name])));
      } catch (error) {
        console.error("Data fetching failed", error);
      }
    }

    fetchData();
  }, []);

  const fields = ['entry_no','entry_date',  'driver_name', 'vehicle_no', 'from_location','challan_no','table_details','from_depot_name'];
  const labels = ['Inward No', 'Inward Date', 'Driver Name',   'Vehicle No','Party Name', 'Challan No','No Of Cylinder','From Depot'];
  const [total_count, setTotalCount] = useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage,
  });

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

const getDepotName = (depotId) => {
  return depotmap[depotId];
};

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await inwardService.getCylinderInwardList(params);
      setRows(response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value;
    setSearchKey(searchValue);
    const params = {
      page: controller.page,
      size: searchValue === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
      searchKey: searchValue,
    };
    try {
      await fetchData(params);
    } catch (error) {
      console.error("Error in handleSearch:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  const deleteRecord = async (id) => {
    try {
      await inwardService.editDeleteCylinderInward({
        inward_id: id,
        changedUpdatedValue: "delete",
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  const handleCylinderCountClick = (row) => {
    try {
      const details = JSON.parse(row.table_details || '[]');
      setSelectedCylinderDetails(details);
      setDialogTitle(`Cylinder Details for ${row.entry_no}`);
      setOpenCylinderDialog(true);
    } catch (error) {
      console.error("Error parsing table_details:", error);
      setSuccessMessage("Error loading cylinder details");
    }
  };

  const handleCloseCylinderDialog = () => {
    setOpenCylinderDialog(false);
    setSelectedCylinderDetails([]);
    setDialogTitle("Cylinder Details");
  };

  const safeParse = (jsonString) => {
    if (jsonString && typeof jsonString === "string") {
      try {
        return JSON.parse(jsonString);
      } catch (e) {
        console.error("Error parsing JSON", e);
        return [];
      }
    }
    return [];
  };

  const dateConversion = (date) => {
    if (!date) return "";
    const today = new Date(date);
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  const handleOpenDialog = (row) => {
    console.log("Opening dialog for row:", row);
    setSelectedRow(row);
    setSelectedCylinderDetails(safeParse(row.table_details));
    setOpenDialog(true);
    console.log("openDialog set to:", true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
    setSelectedCylinderDetails([]);
  };

  const getCylinderCount = (tableDetails) => {
    try {
      const details = JSON.parse(tableDetails || '[]');
      return details.length || 0;
    } catch (error) {
      console.error("Error parsing table_details:", error);
      return 0;
    }
  };


  const getCylinderCountByStatus = (tableDetails) => {
  try {
    const details = JSON.parse(tableDetails || '[]');
    let full = 0, empty = 0;
    details.forEach((c) => {
      const s = (c.status || '').toLowerCase();
      if (s === 'full') full += 1;
      else if (s === 'empty') empty += 1;
    });
    return { full, empty, total: details.length };
  } catch (error) {
    console.error("Error parsing table_details:", error);
    return { full: 0, empty: 0, total: 0 };
  }
};


const getInwardType = (row) => {
  const source = (row.challan_no && row.challan_no.trim() !== "")
    ? row.challan_no
    : (row.empty_challan_no || "");

  if (!source) return "—";

  const prefix = source.split("/")[0].toUpperCase();

  if (prefix === "ECR") return "ECR";
  if (prefix === "DC") return "DC";
  return prefix || "—";  // fallback — jo bhi prefix mile wahi dikha do, debug ke liye
};

  const getOwnerDisplay = (cylinder) => {
    if (!cylinder) return 'N/A';
    const { owner, customer_id } = cylinder;
    if (owner === 'TGPL') return 'TGPL';
    if (owner === 'customer' && customer_id && customermap[customer_id]) {
      return customermap[customer_id];
    }
    return 'N/A';
  };

  const getProductCodesSummary = () => {
  if (!Array.isArray(selectedCylinderDetails) || selectedCylinderDetails.length === 0) return "—";
  const codes = [...new Set(selectedCylinderDetails.map(c => c.prod_code).filter(Boolean))];
  return codes.length > 0 ? codes.join(", ") : "—";
};

  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: '0px !important', margin: '0px !important' }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[{ name: 'Cylinder Inward List' }]}
        />


        <HeaderSection
          title="CYLINDER INWARD LIST"
          addNewPath="/storeEntries/add-ci"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="Cylinder Inward List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />

        <Paper sx={{ width: '100%', }}>
          <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
            <Table size="small" stickyHeader>
              <TableHead>
                <StyledTableRow>
                 <StyledTableCell align="left" className={`${styles.table_head}`}>Entry No</StyledTableCell>
<StyledTableCell align="left" className={`${styles.table_head}`}>Entry Date</StyledTableCell>
     <StyledTableCell align="left" className={`${styles.table_head}`}>Received From </StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`}>Driver Name</StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`}>Vehicle No</StyledTableCell>
             
                  <StyledTableCell align="left" className={`${styles.table_head}`}>Challan No</StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.table_head}`}>Challan Date</StyledTableCell>
                  <StyledTableCell align="left" className={`${styles.table_head}`}>No of Cylinders</StyledTableCell>
                  <StyledTableCell align="center" className={`${styles.table_head}`}>Type</StyledTableCell>
                  {/* <StyledTableCell align="left" className={`${styles.table_head}`}>To Depot</StyledTableCell> */}
{/* <StyledTableCell align="left" className={`${styles.table_head}`}>Product Code</StyledTableCell> */}
                  {/* <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell> */}
                </StyledTableRow>
              </TableHead>
              <TableBody sx={{ backgroundColor: '#fff' }}>
                {Array.isArray(rows) && rows.map((row, index) => (
                  <StyledTableRow
                    key={row.inward_id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    {/* <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {dateConversion(row.entry_date)}
                    </StyledTableCell> */}

                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      <Typography
                        sx={{ fontSize: "12px", fontWeight: "bold", cursor: "pointer", color: "#1976d2", textDecoration: "underline" }}
                        onClick={() => handleOpenDialog(row)}
                      >
                        {row.entry_no}
                      </Typography>
                    </StyledTableCell>

                      <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {dateConversion(row.entry_date)}
                    </StyledTableCell>
  <StyledTableCell align="left" className={`${styles.list_table_body}`}>
  {row.from_location === "customer" ? row.cust_name : getDepotName(row.from_depot_id)}
</StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.driver_name}</StyledTableCell>
                    <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.vehicle_no}</StyledTableCell>
                  

                 <StyledTableCell align="left" className={styles.list_table_body}>
  {row.challan_no && row.challan_no.trim() !== ""
    ? row.challan_no
    : row.empty_challan_no}
</StyledTableCell>

<StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.challan_date}</StyledTableCell>

<StyledTableCell align="center" className={`${styles.list_table_body}`}>
  <Tooltip title="Click here to view cylinder details" arrow>
    <span onClick={() => handleCylinderCountClick(row)} style={{ cursor: 'pointer' }}>
      {(() => {
        const { full, empty } = getCylinderCountByStatus(row.table_details);
        return (
          <>
            <span style={{ color: "#16A34A", fontWeight: 700 }}>F: {full}</span>
            {"  "}
            <span style={{ color: "#DC2626", fontWeight: 700 }}>E: {empty}</span>
          </>
        );
      })()}
    </span>
  </Tooltip>
</StyledTableCell>

{/* 👇 Type cell ab No of Cylinders ke baad */}
<StyledTableCell align="center" className={`${styles.list_table_body}`}>
  <Box
    component="span"
    sx={{
      display: "inline-block",
      px: 1.2,
      py: 0.3,
      borderRadius: "20px",
      fontSize: "11px",
      fontWeight: 700,
      background: getInwardType(row) === "DC" ? "#DCFCE7" : getInwardType(row) === "ECR" ? "#FEF3C7" : "#F1F5F9",
      color: getInwardType(row) === "DC" ? "#16A34A" : getInwardType(row) === "ECR" ? "#D97706" : "#64748B",
    }}
  >
    {getInwardType(row)}
  </Box>
</StyledTableCell>
                    {/* <StyledTableCell align="left" className={`${styles.list_table_body}`}><StyledTableCell align="left" className={`${styles.list_table_body}`}>
  {row.from_depot_name}
</StyledTableCell>
</StyledTableCell> */}
{/* <StyledTableCell align="left" className={`${styles.list_table_body}`}>
                      {row.prod_code || "DA001"}
                    </StyledTableCell> */}

                    {/* <StyledTableCell align="center">
                      <PopupState variant="popover" popupId={`demo-popup-popover-${row.inward_id}`}>
                        {(popupState) => (
                          <>
                            <IconButton {...bindTrigger(popupState)}>
                              <MoreHorizIcon />
                            </IconButton>
                            <Popover
                              {...bindPopover(popupState)}
                              anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                              }}
                            >
                             No actions currently available
                            </Popover>
                          </>
                        )}
                      </PopupState>
                    </StyledTableCell> */}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
                               <CustomPagination
  page={controller.page}
  rowsPerPage={controller.rowsPerPage}
  totalCount={total_count || 0}
  onPageChange={(newPage) => handleChangePage(null, newPage)}
/>
        </Paper>

        {/* ── CYLINDER INWARD DETAILS (Redesigned like Sales Order) ── */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth={false}
          sx={{
            "& .MuiDialog-paper": {
              margin: "auto",
              width: "92vw",
              maxHeight: "85vh",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              overflow: "hidden",
              fontFamily: "'Inter', Arial, sans-serif",
              
            },
          }}
        >
          {/* ── Dialog Header (Navy) ── */}
          <Box sx={{ background: "#1C3A5E", padding: "14px 22px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.5px", fontFamily: "'Inter', Arial, sans-serif" }}>
              CYLINDER INWARD DETAILS
            </Typography>
            <IconButton onClick={handleCloseDialog} sx={{ color: "#fff", p: 0.5 }}>
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <DialogContent sx={{ padding: "20px 24px", background: "#F4F7FB", overflowY: "auto" }}>

            {/* ── Inward Information Card ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0", overflow: "hidden", mb: 2.5 }}>

              {/* Card Header */}
              <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📋  Inward Information
                </Typography>
              </Box>

              {/* Caption Grid (2 rows of 4 columns) */}
              <Box>
                <Grid container>

                  {/* Row 1 */}
           <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      From Location
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.from_location === "customer"
                        ? "Customer"
                        : selectedRow?.from_depot_name || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      From Party
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 700, color: "#1C3A5E", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.from_location === "customer"
                        ? (selectedRow?.cust_name || "—")
                        : (getDepotName(selectedRow?.from_depot_id) || selectedRow?.from_depot_name || "—")}
                    </Typography>
                  </Grid>

                  {/* <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      From Location
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.from_location === "customer"
                        ? "Customer"
                        : selectedRow?.from_depot_name || "—"}
                    </Typography>
                  </Grid> */}

                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Inward No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.entry_no || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Inward Date
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {dateConversion(selectedRow?.entry_date) || "—"}
                    </Typography>
                  </Grid>

                  {/* Row 2 */}
                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Driver Name
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.driver_name || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Vehicle No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.vehicle_no || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      Challan No
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.challan_no || selectedRow?.empty_challan_no || "—"}
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={3} sx={{ borderRight: "1px solid #EDF2F7", borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                     Product Code
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
  {getProductCodesSummary()}
</Typography>
                  </Grid>

                  {/* <Grid item xs={12} sm={6} md={3} sx={{ borderBottom: "1px solid #EDF2F7", padding: "12px 16px" }}>
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "#718096", textTransform: "uppercase", letterSpacing: "0.6px", mb: 0.5, fontFamily: "'Inter', Arial, sans-serif" }}>
                      To Depot
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "#2D3748", fontFamily: "'Inter', Arial, sans-serif" }}>
                      {selectedRow?.from_depot_name || "—"}
                    </Typography>
                  </Grid> */}

                </Grid>
              </Box>
            </Box>

            {/* ── Cylinder Details Table ── */}
            <Box sx={{ background: "#fff", border: "1px solid #E2E8F0",  overflow: "hidden" }}>

              {/* Table Header */}
              {/* <Box sx={{ background: "#2A4F7A", padding: "9px 18px" }}>
                <Typography sx={{ fontSize: "12px", fontWeight: 700, color: "#fff", fontFamily: "'Inter', Arial, sans-serif", letterSpacing: "0.4px" }}>
                  📦  Cylinder Details
                </Typography>
              </Box> */}

              <TableContainer sx={{ maxHeight: "320px" }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                    {[
                        "Sr No", "Cylinder No", "Tag No", "Owner", "Status", "Remark"
                      ].map((header) => (
                        <StyledTableCell
                          key={header}
                          align="center"
                          sx={{
                            backgroundColor: "#1C3A5E !important",
                            color: "#fff !important",
                            fontFamily: "'Inter', Arial, sans-serif",
                            fontWeight: 700,
                            fontSize: "12px",
                            padding: "10px 12px",
                            whiteSpace: "nowrap",
                            borderRight: "1px solid rgba(255,255,255,0.1)",
                          }}
                        >
                          {header}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {selectedCylinderDetails.length > 0 ? (
                      selectedCylinderDetails.map((row, index) => (
                        <StyledTableRow
                          key={index}
                          sx={{
                            backgroundColor: index % 2 === 0 ? "#fff" : "#F8FAFC",
                            "&:hover": { backgroundColor: "#EBF4FF" },
                          }}
                        >
                          {[
                            index + 1,
                            row.cyl_no || "—",
                            row.tag_no || "—",
                            row.owner === "TGPL"
                              ? "TGPL"
                              : row.customer_id
                                ? customermap[row.customer_id] || "Customer"
                                : "—",
                            row.status || "—",
                            row.remark || "—",
                            
                            // row.checked ? "True" : "False"
                          ].map((val, ci) => (
                            <StyledTableCell
                              key={ci}
                              align="center"
                              sx={{
                                fontSize: "12px",
                                fontFamily: "'Inter', Arial, sans-serif",
                                color: "#2D3748",
                                padding: "8px 12px",
                                borderBottom: "1px solid #EDF2F7",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {val}
                            </StyledTableCell>
                          ))}
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <StyledTableCell
                          colSpan={7}
                          align="center"
                          sx={{ py: 5, fontSize: "13px", color: "#A0AEC0", fontFamily: "'Inter', Arial, sans-serif" }}
                        >
                          No cylinder details available
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

          </DialogContent>

          {/* ── Dialog Footer ── */}
          <Box sx={{ padding: "12px 24px", background: "#F8FAFC", borderTop: "1px solid #E2E8F0", display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleCloseDialog}
              sx={{
                background: "#E53E3E",
                color: "#fff",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
                padding: "7px 20px",
                borderRadius: "8px",
                fontFamily: "'Inter', Arial, sans-serif",
                "&:hover": { background: "#971f16" },
              }}
            >
              Close
            </Button>
          </Box>
        </Dialog>




        <Dialog
          open={openCylinderDialog}
          onClose={handleCloseCylinderDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left' }}>
            {dialogTitle}
            <IconButton aria-label="close" onClick={handleCloseCylinderDialog}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Table size="small">
              <TableHead>
                <StyledTableRow>
                  <StyledTableCell>Cylinder No</StyledTableCell>
                  <StyledTableCell>Tag No</StyledTableCell>
                  <StyledTableCell>Owner</StyledTableCell>
                   <StyledTableCell>Status</StyledTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {selectedCylinderDetails.length > 0 ? (
                  selectedCylinderDetails.map((cylinder, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell>{cylinder.cyl_no || 'N/A'}</StyledTableCell>
                      <StyledTableCell>{cylinder.tag_no || 'N/A'}</StyledTableCell>
                      <StyledTableCell>{cylinder.owner}</StyledTableCell>
                         <StyledTableCell>{cylinder.status}</StyledTableCell>
                    </StyledTableRow>
                  ))
                ) : (
                  <StyledTableRow>
                    <StyledTableCell colSpan={4} align="left  ">
                      No cylinder details available
                    </StyledTableCell>
                  </StyledTableRow>
                )}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.inward_id || null}
          displayName={deleteInfo?.inward_id || ''}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};

export default CylinderInwardList;